import { render, staticRenderFns } from "./trainerH2.vue?vue&type=template&id=66ab0410&"
import script from "./trainerH2.vue?vue&type=script&lang=js&"
export * from "./trainerH2.vue?vue&type=script&lang=js&"
import style0 from "./trainerH2.scss?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports